import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "idle",
  error: null,
  message: null,
};

export const updateHomeLinkSlice = createSlice({
  name: "updateHomeLink",
  initialState,
  reducers: {
    updateHomeLinkRequested: (state) => {
      state.status = "loading";
      state.error = null;
      state.message = null;
    },
    updateHomeLinkRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    updateHomeLinkRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.message = action.payload;
    },
  },
});

export const {
  updateHomeLinkRequested,
  updateHomeLinkRequestFailed,
  updateHomeLinkRequestSucceeded,
} = updateHomeLinkSlice.actions;

export default updateHomeLinkSlice.reducer;
